<template>
  <b-container fluid="true">
    <b-row no-gutters>
      <b-col>
        <b-container>
          <b-row>
            <b-col cols="12" class="py-3">
              <TreeViewCard title="Items tree"
                            breakpoint=""
                            :stretch-height="true"
                            :alternate-height="300"
                            :data="lists"
                            :multiSelect="multiSelect"
                            ref="tree"
                            :query="query"
                            v-model="selectionLocal"
                            :recordsWithChosenFilters="recordsWithChosenFilters"
                            @multiSelectChange.sync="multiSelectList"
                            @multiSelectSizeChange.sync="multiSelectListSize"
                            @childNodeMultiSelect="childNodeMultiSelect"
                            @details="showDetails"
                            >
              </TreeViewCard>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import FormConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormConfig";
import PermissionsSet from "@/server/PermissionsSet";
import DataGrid2 from "@/components/datagrid/DataGrid2";
import RtModule from "@/utils/RtModule";
import TemporaryList from "@/components/forms/TemporaryList"
import FormDetailsConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig";
import _ from "lodash";
import {ToolboxButton} from "@/components/navbar/toolbox/ToolboxButton";
import Renderers from "@/components/forms/renderers/Renderers";
import TreeViewCard from "@/components/tree/TreeViewCard";
import TreeElementInfo from "@/server/com/silkplm/forms/TreeElementInfo";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import Events from "@/utils/Events";

export default {
  name: "EntitiesTree",
  components: {TreeViewCard},
  mounted() {
    /** @type {DataGrid2|Vue} */

    this.multiSelect = this.context?.multiSelect;
    if (!this.form) {
      return;
    }

    this.setForm(this.form);

    this.$onDelete(this.form.formClassLong, async (changeEvent) => {
      // if (this.detailsMode === "NEW") {
      //   return;
      // }
      // //this.$refs.grid.removeOne((el) => el.id === changeEvent.id);
      await this.refresh();
    });
    this.$onBulkChange(this.form.formClassLong, async (changeEvent) => {
      // if (this.detailsMode === "NEW") {
      //   return;
      // }
      await this.refresh();
    });

    this.$onInsert(this.form.formClassLong, async (changeEvent) => {
      // if (this.detailsMode === "NEW") {
      //   return;
      // }
      // if (this.detailsConfig)
      //   if (changeEvent.instance) {
      //     if (changeEvent.instance[this.detailsConfig.joiningField] !== this.detailsMasterId) {
      //       return;
      //     }
      //   }
      // let entity = await Rpc.Forms.getExtendedEntity(this.form.formClassLong, changeEvent.id);
      // if(this.formValidatedFieldWithParent){
      //   let parentValue = this.formValidatedFieldWithParent.getParentFkKey();
      //   let field = this.formValidatedFieldWithParent.formFieldConfig.filteringFieldByParent;
      //
      //   if (entity[field] == parentValue) {
      //     this.$refs.grid.pushRow(entity);
      //   }
      // }
      // if (!this.detailsConfig || entity[this.detailsConfig.joiningField] === this.detailsMasterId) {
      //   this.$refs.grid.pushRow(entity);
      // }
      await this.refresh();

    });

    this.$onUpdate(this.form.formClassLong, async (changeEvent) => {
      // if (this.detailsMode === "NEW") {
      //   return;
      // }
      //
      // if (this.detailsConfig &&
      //     changeEvent.instance &&
      //     changeEvent.instance[this.detailsConfig.joiningField] !== this.detailsMasterId) {
      //   return;
      // }
      //
      // let index = this.lists.findIndex(item => item.id === changeEvent.id);
      // if (index != null && index >= 0) {
      //   this.lists[index] = changeEvent.instance;
      //   this.$refs.grid.refreshIndex(index);
      // }
      await this.refresh();
    });
  },
  beforeDestroy() {
    this.permissions.detach();
  },

  methods: {
    // removeTemporaryInstance(instance) {
    //   let index = this.lists.findIndex(item => item.__id__ === instance.__id__);
    //   this.detailsTemporaryList.splice(index, 1);
    // },
    // updateTemporaryInstance(instance) {
    //   let index = this.lists.findIndex(item => item.__id__ === instance.__id__);
    //   this.lists[index] = instance;
    //   this.$refs.grid.refreshIndex(index);
    // },
    //

    /**
     * @param {FormConfig} val
     */
    setForm(val) {
      if (this.form?.formClassLong === val.formClassLong && this.formInitialized) {
        return;
      }

      if (!this.formInitialized) {
        this.selectionLocal = this.selection;
      }

      this.formInitialized = true;
      this.refresh().then();
    },

    async refresh() {
      if (this.detailsMode === "NEW" && this.detailsConfig) {
       // return this.refreshInNewDetailsMode();
      }

      if (this.detailsConfig) {
        // let res = await Rpc.Forms.listDetails(this.detailsMasterFormConfig.formClassLong, this.detailsMasterId, this.detailsConfig.detailsClass, this.detailsConfig.joiningField);
        // this.lists = res;
        // return;
      }

      // let res;
      // if(this.formValidatedFieldWithParent){
      //   res = await this.formValidatedFieldWithParent.getForeignOptionsExtended();
      // } else {
      //   res = await Rpc.Forms.listExtendedEntities(this.form.formClassLong);
      // }
      let res;
      if(this.filter?.instance){
//        this.filter
        res = await Rpc.Forms.listExtendedTreeEntitiesWithFiltering(this.form.formClassLong, this.filter.fieldName,
            FormsLoader.detectFormConfig(this.filter.instance).formClassLong, this.filter.instance);
      } else {
        res = await Rpc.Forms.listExtendedTreeEntities(this.form.formClassLong);
      }
      if(this.excludedBranch){
        res = this.filterRec(res, this.excludedBranch);
      }
      this.lists = res;
    },

    filterRec(listOfTreeInfos, excludedTreeInfoRoot){
      let res = [];
      for(let info of listOfTreeInfos){
        if(info.element.id == excludedTreeInfoRoot?.element?.id){
          continue;
        }
        info.children = this.filterRec(info.children, excludedTreeInfoRoot);
        res.push(info);
      }


      return res;
    },

    async refreshInNewDetailsMode() {
      //this.lists = this.detailsTemporaryList?.items ?? [];
    },

    refreshColumns() {
      //this.$refs.grid.colsVersion++;
    },


    isRootSelected(){
      if(!this.selectionLocal || !this.lists || !this.lists.length){
        return false;
      }
      return this.selectionLocal === this.lists[0];
    },

    isfixedRootsMode(){
      return this.form.extendedConfigs.TreeConfig.fixedRoots
    },

    childNodeMultiSelect(node, isSelected) {
      // console.log(node)
      // forward event to the parent node
      if(!isSelected){
        this.localMultiSelection.delete(node.getKey());
      } else {
        this.localMultiSelection.add(node.getKey());
      }

      this.seletionSize = this.localMultiSelection.size;
      this.$emit(Events.treeViewNodeMultiSelect, node, isSelected)
    },
    showDetails(data) {
      this.$emit("details", data);
    },

  },
  props: {
    form: {type: BaseFormConfig},
    query: {default: ""},
    context: {default:null},
    recordsWithChosenFilters: {default: null},
    detailsMasterFormConfig: {type: BaseFormConfig},
    detailsConfig: {type: FormDetailsConfig, default: null},
    detailsMasterId: {type: String, default: null},
    detailsMode: {type: String, default: ""},
    detailsTemporaryList: {type: TemporaryList, default: null},
    excludedBranch: {default:null},
    metaStatus: {type: Boolean, default: false},

    filter: {default: null}
  },
  model: {
    prop: 'selection',
    event: 'model-change',
  },
  watch: {
    'form': function (val) {
      this.setForm(val);
    },
    'selectionLocal': function (val) {
      this.$emit("model-change", val);
    },
    'detailsTemporaryList': function (val) {
      this.refresh();
    },
    metaStatus: function (val) {
      this.refreshColumns();
    }
  },

  data: () => {
    return {
      localMultiSelection: new Set(),
      selectionSize: 0,
      multiSelect: false,
      permissions: new PermissionsSet(),
      selectionLocal: null,
      /** @type {DataGrid2|Vue} */
      grid: null,
      lists: [],
      multiSelectList: [],
      multiSelectListSize: 0,
      formInitialized: false,
      toolbox: [],
    }
  }
}
</script>

<style scoped>

</style>